<template>
<!-- 考生成绩列表 列表页 -->
    <div class="board">
        <div v-hasPermi="['review:result:list']">
            <div class="title">
                <span><el-button type="text" icon="el-icon-arrow-left" @click="$router.push({name:'achievement'})">{{ examineeScoreTextConfig.back }}</el-button><el-divider direction="vertical"></el-divider><span class="name">{{ examineeScoreTextConfig.title }}</span></span>
                <el-button v-hasPermi="['review:plan:export']" type="primary" @click="exportDialogVisible = true">
                    {{ examineeScoreTextConfig.export }}</el-button>
            </div>
            <p class="info">
                <span>{{ infoTextConfig.examPlan }}：</span>{{info.examPlanName}} <span>{{ infoTextConfig.subject }}：</span>{{info.subject}} <span>{{ infoTextConfig.examPaperName }}：</span>{{info.examPaperName}} <span>{{ infoTextConfig.examTime }}：</span>{{info.startTime + ' ~ ' + info.endTime}}
            </p>
            <el-form :inline="true" :model="form" ref="form">
                <el-form-item>
                    <el-input v-model.trim="form.examineeName" clearable :placeholder="searchTextConfig.examineeName"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input v-model.trim="form.admissionNo" clearable :placeholder="searchTextConfig.admissionNo"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input
                        v-model.trim="form.startScore"
                        type="number"
                        min="0"
                        clearable
                        :placeholder="searchTextConfig.startScore" style="width:120px">
                    </el-input> -
                    <el-input
                        v-model.trim="form.endScore"
                        type="number"
                        min="0"
                        clearable
                        :placeholder="searchTextConfig.endScore" style="width:120px">
                    </el-input>
                </el-form-item>
                <el-form-item>
                    <el-select v-model="form.reviewStatus" clearable :placeholder="searchTextConfig.reviewStatus">
                        <el-option
                            v-for="item in statusOptions"
                            :key="item.dict_value"
                            :label="item.dict_label"
                            :value="item.dict_value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-select v-model="form.examStatus" clearable :placeholder="searchTextConfig.examStatus">
                        <el-option
                            v-for="item in examStatusOptions"
                            :key="item.dict_value"
                            :label="item.dict_label"
                            :value="item.dict_value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="search(1)">{{ searchTextConfig.button.search }}</el-button>
                    <el-button @click="reset">{{ searchTextConfig.button.reset }}</el-button>
                </el-form-item>
            </el-form>
            <el-table :data="tableData" v-loading="loading" element-loading-text="加载中" element-loading-spinner="el-icon-loading" ref="multipleTable" stripe size="medium" :height="height" style="width:100%">
                <el-table-column prop="examineeName" :label="tableTextConfig.examineeName" min-width="150px" show-overflow-tooltip></el-table-column>
                <el-table-column prop="admissionNo" :label="tableTextConfig.admissionNo" min-width="150px" show-overflow-tooltip></el-table-column>
                <el-table-column prop="commitDate" :label="tableTextConfig.commitAnswerTime" min-width="170px" show-overflow-tooltip>
                    <template slot-scope="scope">{{scope.row.commitDate}}</template>
                </el-table-column>
                <el-table-column :label="tableTextConfig.score" min-width="80">
                    <template slot-scope="scope">
                        <el-tooltip placement="right" v-if="scope.row.questionTypeScoreList && scope.row.totalScore">
                            <div slot="content" style="line-height:22px">
                                <span v-for="(e,j) in scope.row.questionTypeScoreList" :key="j">{{getTagValue(e.questionType, questionTypeList)}}：{{e.score}}<br/></span>
                            </div>
                            <el-button type="text" size="medium">{{scope.row.totalScore}}</el-button>
                        </el-tooltip>
                        <span v-else>{{scope.row.totalScore}}</span>
                    </template>
                </el-table-column>
                <el-table-column :label="tableTextConfig.reviewStatus" min-width="120px">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.reviewStatus !== null" :type="scope.row.reviewStatus===1?'warning':scope.row.reviewStatus===2?'success':scope.row.reviewStatus===3?'info':''">{{getTagValue(scope.row.reviewStatus, statusOptions)}}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column :label="tableTextConfig.examStatus" min-width="120px">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.examStatus===0?'success':(scope.row.examStatus===1?'info':'danger')">{{getTagValue(scope.row.examStatus, examStatusOptions)}}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column fixed="right" :label="tableTextConfig.operate" min-width="232px">
                    <template slot-scope="scope">
                        <el-button
                            v-hasPermi="['review:result:list']"
                            plain
                            type="primary"
                            size="mini"
                            v-if="scope.row.examStatus!==1"
                            @click="lookPaper(scope.row)">
                            {{ tableButtonTextConfig.detail }}
                        </el-button>
                        <el-button
                            v-hasPermi="['review:reviewAgain']"
                            plain
                            type="primary"
                            size="mini"
                            v-if="(scope.row.reviewStatus===1 || scope.row.reviewStatus===2) && info.haveReviewSubjective && new Date() < new Date(info.reviewEndTime) && info.examCategory !== 'train'"
                            @click="reprintDialogVisible = true, row = scope.row.answerSheetId">
                            {{ tableButtonTextConfig.reprint.name }}
                        </el-button>
                        <el-button
                            v-hasPermi="['arrangement:examinee:updateExamStatus']"
                            v-if="scope.row.examStatus===0 && info.examCategory !== 'train'"
                            plain
                            type="primary"
                            size="mini"
                            @click="specialDialogVisible = true, row = scope.row.examineeId">
                            {{ tableButtonTextConfig.special.name }}
                        </el-button>
                        <el-button
                            v-hasPermi="['arrangement:examinee:updateExamStatus']"
                            v-if="scope.row.examStatus === 2 || scope.row.examStatus === 3 && info.examCategory !== 'train'"
                            plain
                            type="primary"
                            size="mini"
                            @click="revoke(scope.row.examineeId)">
                            {{ tableButtonTextConfig.revoke.name }}
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <pagination v-show="tableData.length" :currentPage.sync="form.pageNumber" :pageSize.sync="form.pageSize" :total.sync="total"></pagination>
            <export-dialog :row.sync="info" :show.sync="exportDialogVisible" @close="close"></export-dialog>
            <special-dialog :row.sync="row" :show.sync="specialDialogVisible" @close="close"></special-dialog>
            <reprint-dialog :row.sync="row" :show.sync="reprintDialogVisible" @close="close"></reprint-dialog>
        </div>
    </div>
</template>

<script>
import specialDialog from './components/special.vue'
import exportDialog from './components/export.vue'
import reprintDialog from './components/reprint.vue'
import pagination from '@/components/pagination/pagination.vue'
import {getDict} from "@/api/dict";
export default {
    name: 'examineeScore',
    components: {
        specialDialog, exportDialog, reprintDialog, pagination
    },
    data() {
        return {
            height:250,
            loading: true,
            info: {},
            form: {
                examId: '',
                admissionNo: '',
                endScore: '',
                startScore: '',
                examStatus: '',
                reviewStatus: '',
                examineeName: '',
                pageNumber: 1,
                pageSize: 20
            },
            total: 0,
            gradeOptions: [],
            typeOptions: [],
            statusOptions: [],
            examStatusOptions: [],
            questionTypeList: [],
            tableData: [],
            specialDialogVisible: false,
            reprintDialogVisible: false,
            exportDialogVisible: false,
            row: null,
        }
    },
    computed: {
        examineeScoreTextConfig() {
            return this.$store.state.global.textConfig.backend.examineeScore
        },
        infoTextConfig() {
            return this.examineeScoreTextConfig.info
        },
        searchTextConfig() {
            return this.examineeScoreTextConfig.search
        },
        tableTextConfig() {
            return this.examineeScoreTextConfig.table
        },
        tableButtonTextConfig() {
            return this.tableTextConfig.button
        },
    },
    watch: {
        tableData () {
            if (this.tableData.length == 0) {
                this.height = 120
            }else {
                this.updateHeight()
            }
        }
    },
    inject: ['reload'],
    beforeRouteEnter(to, from, next) {
        if (from.name === 'achievement') {
            next(vm => {
                vm.reload()
            })
        } else if (from.name === 'lookPaper') {
            to.meta.isBack = true
            next()
        } else {
            to.meta.isBack = false
            next()
        }
    },
    activated() {
        if (!this.$route.meta.isBack) {
            this.reset()
        } else {
            this.$route.meta.isBack = false
            // this.getBorrowList() /*列表重新加载*/
        }
        this.$route.meta.keepAlive = true
    },
    created() {
        this.initDictData()
        this.info = JSON.parse(localStorage.getItem('setExamineeScoreInfo'))
        this.$store.dispatch('getAllReviewer').then(res => {
            if (res.status === 200) {
                let teacherList = []
                for (let i = 0; i < res.data.length; i++) {
                    const e = res.data[i];
                    teacherList.push({ teacherId: e.userId, teacherName: e.realname })
                }
                this.$store.dispatch('updateReviewTeacherList', teacherList)
            }
        })
        this.search(1)
    },
    mounted() {
        const that = this;
        setTimeout(() => {
            that.updateHeight()
        }, 200);
        window.onresize = () => {
            that.updateHeight()
        };
    },
    methods: {
        initDictData() {
            getDict('review_status').then(res => {
                this.statusOptions = res.data
            });
            getDict('exam_status').then(res => {
                this.examStatusOptions = res.data
            });
            getDict('question_type').then(res => {
                this.questionTypeList = res.data
            });
        },
        getTagValue(val, options) {
            let already = options.find(item => item.dict_value == val)
            return already ? already.dict_label : ''
        },
        search(val) {
            this.loading = true
            if (val) {
                this.form.pageNumber = val
            }
            this.form.examId = this.info.id
            this.form.examPaperId = this.info.examPaperId
            this.$store.dispatch("getExamineeScoreList", this.form).then(res => {
                if (res.status==200) {
                    this.tableData = res.data.list
                    this.total = res.data.total
                }
                this.loading = false
                this.$refs.multipleTable.bodyWrapper.scrollTop = 0;
            }).catch(err => {
                this.loading = false
            })
        },
        lookPaper(row) {
            localStorage.setItem('setExamineePaperInfo', JSON.stringify(row))
            this.$router.push({name:'lookPaper'})
        },
        reset() {
            this.form = this.$options.data().form
            this.form.startScore = ' '
            this.form.endScore = ' '
            this.form.pageSize = 20
            this.search(1)
        },
        edit(row) {
            this.row = row
            this.specialDialogVisible = true
        },
        revoke(id) {
            let revokeTextConfig = this.tableButtonTextConfig.revoke
            this.$confirm(revokeTextConfig.message, revokeTextConfig.title, {
                confirmButtonText: revokeTextConfig.ok,
                cancelButtonText: revokeTextConfig.cancel,
                type: 'warning'
            }).then(() => {
                this.$store.dispatch("putSpecialTreatment", { examineeId: id,examStatus: 0 }).then(res => {
                    if (res.status === 200) {
                        this.$message({
                            type: 'success',
                            message: revokeTextConfig.success
                        });
                        this.search(1)
                    }
                });
            })
        },
        close(data) {
            this.specialDialogVisible = data
            this.reprintDialogVisible = data
            this.exportDialogVisible = data
            this.row = null
        },
        updateHeight() {
            if (document.getElementsByClassName('el-form')[0]) {
                this.height = document.getElementsByClassName('board')[0].clientHeight - document.getElementsByClassName('el-form')[0].clientHeight - 184
                this.height = this.height < 460 ? 460 : this.height
            }
        }
    }
}
</script>

<style scoped>
.info {
    color: #555;
    font-size: 15px;
    margin-bottom: 12px;
}
.info span {
    color: #C0C4CC;
    margin-left: 12px;
}
.info span:first-child {
    margin-left: 0;
}
.info i {
    color: #555;
}
</style>
